package ui.themePlusContext

import react.*
import react.dom.html.ReactHTML
import ui.component.external.ToastBuilder
import ui.styles.ToastStyles
import utils.logger.log
import kotlin.js.Date

enum class ToastTypes(
    val typeText: String
){
    ERROR(
        typeText = "error",
    ),
    INFO(
        typeText = "info",
    ),
    WARNING(
        typeText = "warning",
    ),
    SUCCESS(
        typeText = "success",
    )
}

data class ToastData(
    val message: String,
    val type: ToastTypes = ToastTypes.INFO,
    val timeout: Int = 3000,
    val closeBtn: Boolean = true,
    val closable: Boolean = true,
)

data class ToastContextProp(
    val open: (
        data: ToastData
            ) -> Unit,
    val close: (
            id: String
            ) -> Unit
)

val ToastContext = createContext<ToastContextProp>(
    ToastContextProp(open = { _ -> }, close = { _ -> })
)


data class ToastBuilderData(
    var data: ToastData,
    var id: String,
)


val ToastProvider = FC <PropsWithChildren>{
    var toasts by useState<List<ToastBuilderData>>(emptyList())

    fun openToast(data: ToastData) {
        log.d("[toast] create $data")
        val newToast = ToastBuilderData(
            data = data,
            id = Date.now().toString()
        )
        toasts = toasts.plus(newToast)
    }

    fun closeToast(id: String) {
//        log.d("[toast] close toast with id $id")
        toasts = toasts.filter { toastData ->
            toastData.id != id
        }
    }

//    val contextValue = useMemo(){
//        ToastContextProp(
//            open = {message->
//                openToast(message)
//            },
//            close = {id->
//                closeToast(id)
//            }
//        )
//    }

    val contextValueNoMemo = ToastContextProp(
        open = {data->
            openToast(data)
        },
        close = {id->
            closeToast(id)
        }
    )

    ToastContext.Provider{
        value = contextValueNoMemo

        +it.children

        ReactHTML.div{
            className = ToastStyles.toasts

            toasts.map { toast ->
                ToastBuilder{
                    this.key = toast.id
                    this.data = toast.data
                    this.close = {
                        closeToast(toast.id)
                    }
                }
            }
        }
    }
}

fun useToastContext() = useContext(ToastContext)